module.exports = __webpack_public_path__ + "img/application_black_icon.adc3ddb0.svg";